module.exports = __webpack_public_path__ + "static/media/69_tn.2b8fe97d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/69_tn.jpg
// module id = 555
// module chunks = 0